'use client';
import { Conditional } from '@cat-ecom/pcc-components';
import { EquipmentListWrapper } from '../equipment-list-wrapper';
import styles from '../../customer-account.module.scss';
import { NoActiveEquipment } from '../no-active-equipment';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { MyEquipmentHeader } from '../my-equipment-header';
import { useTransition } from 'react';
import { equipmentListFilterWithSearch } from 'services/equipment/utils';
import { SelectedEquipment } from '../selected-equipment';
import { MyEquipmentLoader } from '../my-equipment-loader';
import { EquipmentWrapperProps } from '../../types';
import { NoEquipment } from '../no-equipment';
import EquipmentSuccessToast from 'app/[lang]/[esite]/(core)/my-equipment/_components/equipment-success-toast';
import { MyEquipmentErrorMessage } from '../my-equipment-error-message';

export const MyEquipmentContainer = ({
  userDetail,
  myEquipmentList,
  selectedEquipmentIndex,
  serviceInsights,
  isVirtualScrollFeatureEnabled,
  storeId,
  isError,
  isAssetLandingFeatureFlag
}: EquipmentWrapperProps) => {
  const [isPending, startTransition] = useTransition();

  const selectedEquipment =
    selectedEquipmentIndex > -1
      ? myEquipmentList[selectedEquipmentIndex]
      : null;
  const equipmentList = equipmentListFilterWithSearch(
    myEquipmentList ?? [],
    selectedEquipmentIndex,
    ''
  );
  const hasEquipments = equipmentList?.length > 0;
  const transitionCallBack = (callBack) => {
    startTransition(callBack);
  };

  const hasSelectedEquipment = selectedEquipmentIndex > -1;
  const hasMultipleEquipments = (myEquipmentList || []).length > 1;

  return (
    <Conditional test={!isPending} fallback={<MyEquipmentLoader />}>
      <EquipmentSuccessToast userDetail={userDetail} />
      <Conditional test={hasSelectedEquipment || isError}>
        <MyEquipmentHeader showChangeButton={hasMultipleEquipments} />
      </Conditional>
      <Conditional test={!isError} fallback={<MyEquipmentErrorMessage />}>
        <Conditional
          test={hasEquipments}
          fallback={<NoEquipment storeId={storeId} {...userDetail} />}
        >
          <div className="row g-0 pt-blg-4">
            <div className="col-blg-6 col-md-12">
              <Conditional test={!selectedEquipment}>
                <NoActiveEquipment />
              </Conditional>
              <Conditional test={!isEmpty(selectedEquipment)}>
                <div
                  className={styles['my-equipment--selected-equipment-wrapper']}
                >
                  <SelectedEquipment
                    userDetail={userDetail}
                    selectedEquipment={selectedEquipment}
                    myEquipmentList={myEquipmentList}
                    selectedEquipmentIndex={selectedEquipmentIndex}
                    startTransition={transitionCallBack}
                    isPending={isPending}
                    serviceInsights={serviceInsights}
                    isAssetLandingFeatureFlag={isAssetLandingFeatureFlag}
                  />
                </div>
              </Conditional>
            </div>
            <div
              className={`${styles['my-equipment--list']} col-6 ps-3 pe-4 d-none d-blg-block`}
            >
              <EquipmentListWrapper
                equipmentList={equipmentList}
                selectedEquipment={selectedEquipment}
                userDetail={userDetail}
                serviceInsights={serviceInsights}
                isVirtualScrollFeatureEnabled={isVirtualScrollFeatureEnabled}
                startTransition={transitionCallBack}
              />
            </div>
          </div>
        </Conditional>
      </Conditional>
    </Conditional>
  );
};
